import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { Region } from '../../../../model/region.model';

@Injectable({
    providedIn: 'root'
})
export class OrganizationService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    // Search by ID
    public show(id: number): Observable<any> {
        return this.get<any>(EndPoints.organization_show, false, id);
    }

    getPartyRoles(id: number): Observable<any> {
        return this.get<any>(EndPoints.organization_getPartyRoles, false, id);
    }

    searchById(id: number): Observable<any> {
        return this.get<any>(EndPoints.organization_searchById, false, id);
    }

    // With Region
    search(searchString: string, searchRegion?: Region): Observable<any> {
        return this.post<any>(EndPoints.organization_search, false, '', {
            searchString: searchString,
            searchRegion: searchRegion
        });
    }

    searchSchoolDistricts(searchString: string, searchRegion?: Region): Observable<any> {
        return this.post<any>(EndPoints.organization_searchSchoolDistricts, false, '', {
            searchString: searchString,
            searchRegion: searchRegion
        });
    }

    searchSchools(searchString: string, searchRegion?: Region): Observable<any> {
        return this.post<any>(EndPoints.organization_searchSchools, false, '', {
            searchString: searchString,
            searchRegion: searchRegion
        });
    }

    searchLegalOrganizations(searchString: string, searchRegion?: Region): Observable<any> {
        return this.post<any>(EndPoints.organization_searchLegalOrganizations, false, '', {
            searchString: searchString,
            searchRegion: searchRegion
        });
    }

    searchMSINSchools(searchString: string, searchRegion?: Region): Observable<any> {
        return this.post<any>(EndPoints.organization_searchMSINSchools, false, '', {
            searchString: searchString,
            searchRegion: searchRegion
        });
    }

    searchAll(searchString: string, searchRegion?: Region): Observable<any> {
        return this.post<any>(EndPoints.organization_searchAll, false, '', {
            searchString: searchString,
            searchRegion: searchRegion
        });
    }

    // Without Region
    searchNoRegion(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.organization_searchNoRegion, false, '', {
            searchString: searchString
        });
    }

    searchRegions(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.organization_searchRegions, false, '', {
            searchString: searchString
        });
    }

    searchNone(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.organization_searchNone, false, '', {
            searchString: searchString
        });
    }

    searchNotARegion(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.organization_searchNotARegion, false, '', {
            searchString: searchString
        });
    }

    searchRegionByOrganizationName(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.organization_searchRegionByOrganizationName, false, '', {
            searchString: searchString
        });
    }

    searchSchoolDistrictsInRegion(searchString: string): Observable<any> {
        return this.post<any>(EndPoints.organization_searchSchoolDistrictsInRegion, false, '', {
            searchString: searchString
        });
    }

    // Other
    getSchoolByRegionDistrict(studentRegion: any, schoolDistrict: any): Observable<any> {
        return this.post<any>(EndPoints.organization_getSchoolByRegionDistrict, false, '', {
            StudentRegion: studentRegion,
            SchoolDistrict: schoolDistrict
        });
    }

    getGradesTable(): Observable<any> {
        return this.get<any>(EndPoints.schoolGradesTable);
    }

    updateOrganization(payLoad: any): Observable<any> {
        return this.post<any>(EndPoints.organization_update, false, '', payLoad);
    }

    createOrganization(payLoad: any): Observable<any> {
        return this.post<any>(EndPoints.organization_create, false, '', payLoad);
    }
}
